import { render, staticRenderFns } from "./Runit.vue?vue&type=template&id=507c4d64"
import script from "./Runit.vue?vue&type=script&lang=js"
export * from "./Runit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports